<style lang="less" scoped>
    .demo-split{
        margin-top: 20px;
        height: 300px;
        border: 1px solid #dcdee2;
    }
    .demo-split-pane{
        padding: 10px;
        overflow: auto;
        height: 100%;
    }
    .modal {
        /deep/ .ivu-modal-body {
            min-height: 500px!important;
        }        
    }   
</style>
<template>
  <div class="contain">
    <Modal
      v-model="showModal"
      class="modal"
      :title="modalTitle"
      :closable="false"
      width="800"
    >
      <div>
        <div
          v-show="display===1"
          style="width:300px"
        >
          <Selector @on-change="selectorNewOne" />              
        </div>
        <div class="demo-split">
          <Split v-model="split1">
            <div
              slot="left"
              class="demo-split-pane"
            >
              <p v-show="display===1">
                新增组员
              </p>
              <p v-show="display===2">
                需删除组员
              </p>
              <div>
                <Tag
                  v-for="(item,index) in targetArr"
                  :key="item.id"
                  type="border"
                  closable
                  color="primary"
                  @on-close="closeTargetArr(index)"
                >
                  {{ item.account }}
                </Tag>
              </div>
            </div>
            <div
              slot="right"
              class="demo-split-pane"
              style="overflow:auto"
            >
              <p>已有组员</p>
              <div>
                <Tag
                  v-for="(item,index) in (selectedPeopleClone ||[])"
                  :key="item.id"
                  :closable="display===2"
                  style="margin: 10px 10px 0 0"
                  size="medium"
                  @on-close="closeSouceData(index)"
                >
                  {{ item.account }}
                </Tag>
              </div>
            </div>
          </Split>
        </div>
      </div>
      <div slot="footer">
        <Button
          @click="cancel"
        >
          取消
        </Button>
        <Button
          type="primary"
          :loading="saveloading"
          @click="ok"
        >
          保存
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import Selector from './../../../components/customer/selector.vue'
  export default {
    components: { Selector },
    props: {
      display: {
        type: Number,
        default:() => 0
      },
      formProps: {
        type:Object,
        default:() => ({})
      },
      saveloading:{
        type:Boolean,
        default:() => false
      },
      selectedPeople: {
        type: Array,
        default:() => []
      }
    },
    data() {
      return {
        split1: 0.5,
        formdata: {},
        modalTitle:'',
        showModal: false,
        targetArr: [],
        selectedPeopleClone:[]
      }
    },
    watch: {
      display(value) {
        if (value === 1) {
          this.modalTitle = '新增成员'
          this.targetArr = []
        }
        if (value === 2) {
          this.modalTitle = '删除成员'
          this.targetArr = []
        }
        if (value === 0) {
          this.showModal = false
        } else {
          this.showModal = true
        }
        this.selectedPeopleClone = [...this.selectedPeople]
      }
    },
    methods: {
      selectorNewOne(data) {
        // this.selectedPeopleClone.some(item => item.id===data.id)
        if (this.targetArr.some(item => item.id === data.id)) {
          this.$Message.warning({
            content:'该员工已存在于新增组员中',
            duration: 1.5
          })
          return 
        }
        if (this.selectedPeopleClone.some(item => item.id === data.id)) {
          this.$Message.warning({
            content:'该员工已存在于已有组员中',
            duration: 1.5
          })
          return 
        }
        this.targetArr.push(data)
      },
      closeTargetArr(index) {
        if (this.display === 2) {
          this.selectedPeopleClone.push(this.targetArr[index])
        }
        this.targetArr.splice(index, 1)
      },
      closeSouceData(index) {
        this.targetArr.push(this.selectedPeopleClone[index])
        this.selectedPeopleClone.splice(index, 1)
      },
      ok() {
        if (this.targetArr.length === 0) {
          this.$Message.warning({
            content:'无数据可提交',
            duration: 1
          })
          return
        }
        this.$emit('ok', this.display, this.targetArr.map(item => item.id))  
      },
      cancel() {
        this.$emit('cancel')
      }
    }
  }
</script>
